import { mapActions } from "vuex";
import { types as User } from "@/store/user";
import { sendSmsCode, getCodeImage } from "@/libs/api";
const actions = mapActions({
	setLogin: User.LOGIN_IN,
});
export default {
	name: "login",
	components: {},
	data() {
		return {
			title: "手机号码",
			phoneUsername: "",
			accountUsername: "",
			password: "",
			computed: "",
			code: "",
			clauseChecked: false,
			passwordChecked: false,
			passwordType: "password",
			loginType: "phone", // 登录类型 phone-收取验证登录  account-登入密码登录
			emailReg: /[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
			phoneReg: /^1[3|4|5|6|7|8|9][0-9]{9}$/,
			showCodeImg: "",
			codeImg: "",
			imgKey: "",
			time: 60 * 1000, //60秒
			isCountDown: false, // 是否可以倒计时
		};
	},
	created() {},
	mounted() {
		document.querySelector("body").classList.add("bg-fff");
		this.$once("hook:beforeDestroy", () => {
			document.querySelector("body").classList.remove("bg-fff");
		});
		// 如果已登录
		if (this.$cookies.get("mall_cookie") || this.$cookies.get("ul_utk")) {
			this.$router.push("/");
		} else {
			this.getImg();
		}
	},
	methods: {
		...actions,
		// 登录
		onSubmit() {
			// 手机号登录
			if (this.loginType === "phone") {
				// 手机号校验
				let mobile = this.checkMobile(this.phoneUsername);
				if (!mobile) return false;
				// 计算结果校验
				let computed = this.isCodeEmpty(this.computed, "请输入计算结果");
				if (!computed) return false;
				// 验证码校验
				let code = this.isCodeEmpty(this.code, "请输入验证码");
				if (!code) return false;
				// 协议是否勾选
				if (!this.clauseChecked) {
					this.$toast("您必须同意邮乐用户协议及隐私政策后才能提交注册");
					return false;
				}
				// 全部通过
				let user = {
					type: "phone",
					user: {
						mobile: this.encrypted(this.phoneUsername),
						validateCode: this.code,
						piccode: this.computed,
						imgKey: this.imgKey,
					},
				};
				this.login(user);
			}
			// 账号登录
			else if (this.loginType === "account") {
				// 账号校验
				let account = this.checkAccount(this.accountUsername);
				if (!account) return false;
				// 密码校验
				let password = this.isCodeEmpty(this.password, "请输入密码");
				if (!password) return false;
				// 计算结果校验
				let computed = this.isCodeEmpty(this.computed, "请输入计算结果");
				if (!computed) return false;
				// 全部通过
				let user = {
					type: "account",
					user: {
						username: this.encrypted(this.accountUsername),
						pwd: this.encrypted(this.password),
						piccode: this.computed,
						imgKey: this.imgKey,
					},
				};
				this.login(user);
			}
		},
		// 手机号校验
		checkMobile(moblie) {
			let hasMobil = this.isCodeEmpty(moblie, "请输入您的手机号");
			if (!hasMobil) {
				return false;
			} else {
				let isMoblie = this.isMoblie(moblie);
				if (!isMoblie) {
					return false;
				} else {
					return true;
				}
			}
		},
		// 账号校验
		checkAccount(account) {
			let hasAccount = this.isCodeEmpty(account, "请输入您的手机号或email");
			if (!hasAccount) {
				return false;
			} else {
				let isAccount = this.isAccount(account);
				if (!isAccount) {
					return false;
				} else {
					return true;
				}
			}
		},
		// 校验为空
		isCodeEmpty(code, message) {
			if (code === "") {
				this.$toast(message);
				return false;
			} else {
				return true;
			}
		},
		// 校验手机
		isMoblie(moblie) {
			if (!this.phoneReg.test(moblie)) {
				this.$toast("请输入正确的手机号码");
				return false;
			} else {
				return true;
			}
		},
		// 校验账号
		isAccount(account) {
			if (!this.emailReg.test(account) && !this.phoneReg.test(account)) {
				this.$toast("请输入正确的手机号码或email");
				return false;
			} else {
				return true;
			}
		},
		// 加密
		encrypted(str) {
			window.CryptoJS.pad.ZeroPadding = {
				pad: function(data, blockSize) {
					// Shortcut
					var blockSizeBytes = blockSize * 4;

					// Pad
					data.clamp();
					data.sigBytes += blockSizeBytes - (data.sigBytes % blockSizeBytes || blockSizeBytes);
				},

				unpad: function(data) {
					// Shortcut
					var dataWords = data.words;

					// Unpad
					var i = data.sigBytes - 1;
					while (!((dataWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff)) {
						i--;
					}
					data.sigBytes = i + 1;
				},
			};
			var key = window.CryptoJS.enc.Latin1.parse("aZcdule123456782");
			var iv = window.CryptoJS.enc.Latin1.parse("0z234567ulebcde7");
			var encrypted = window.CryptoJS.AES.encrypt(str, key, {
				iv: iv,
				mode: window.CryptoJS.mode.CBC,
				padding: window.CryptoJS.pad.ZeroPadding,
			});
			return encrypted.toString() || str;
		},
		// 获取短消息验证码
		getCode() {
			// 手机号校验
			let mobile = this.checkMobile(this.phoneUsername);
			if (!mobile) return false;
			// 计算结果校验
			let computed = this.isCodeEmpty(this.computed, "请输入计算结果");
			if (!computed) return false;
			let params = {
				mobile: this.encrypted(this.phoneUsername),
				piccode: this.computed,
				imgKey: this.imgKey,
			};
			sendSmsCode(params).then((res) => {
				if (res.returnCode === "0000") {
					this.$toast("短消息验证码发送成功");
					this.isCountDown = true;
					// 开始倒计时
					this.$refs.countDown.start();
				} else {
					this.$toast(res.returnMessage);
				}
			});
		},
		// 获取图形验证码
		getImg() {
			getCodeImage(null, "jsoncallback").then((res) => {
				this.showCodeImg = `//${res.url}`;
				this.codeImg = res.url;
				this.imgKey = res.key;
			});
		},
		// 登录
		login(params) {
			this.setLogin(params).then((res) => {
				if (res.code === "200") {
					this.$router.push("/");
				} else {
					this.phoneUsername = "";
					this.accountUsername = "";
					this.password = "";
					this.computed = "";
					this.code = "";
					this.getImg();
					this.$toast(res.data.returnMessage);
				}
			});
		},
		// 倒计时结束回调
		finish(e) {
			if (e.seconds === 0) {
				this.isCountDown = false;
				this.$refs.countDown.reset();
			}
		},
	},
};
